export default "__VITE_ASSET__BWg7ZLYD__"